import {permissionObj} from '../../../../../Helpers/permission';
import ButtonAction from '../../../../../components/buttons/ButtonAction';
import {
    AddIcon,
    CleanIcon,
    EditIcon,
    PersonChipBlack
} from '../../../../../components/buttons/IconButtons';
import HeadTittle from '../../../../../components/HeadTittle';
import React from 'react';
import DivContainerBody from '../../../../../components/DivContainerBody';
import DividerWithText from '../../../../../components/DividerWithText';
import {CustomTextField} from '../../../../../components/CustomTextField';
import AddEditShiftApp from '../Functionality/AddEditShiftApp';
import {CustomAddChip} from '../../../../../components/CustomAddChip';
import routes from '../../../../../Routes/routes';
import ButtonIcon from '../../../../../components/buttons/ButtonIcon';
import {filterByLabelEmailPhone, userListToLabelEmailPhoneValue} from "../../../../../Apis/functions";
import {USER_TYPE_MODEL} from "../../../../../enums/userTypeEnum";
import CustomAddChipSearch from "../../../../../components/CustomAddChipSearch";

/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 * @returns {JSX.Element}
 * @constructor
 */
const AddEditShift = () => {

    const {id,
        t,
        DEV,
        permission,
        item,
        disabled,
        emptyFields,
        handleChange,
        cafeteriasOptions,
        departmentsOptions,
        cafeterias, setCafeterias,
        user, setUser,
        departments, setDepartments,
        handleAddEdit,
        handleClearFields,
        cleanChip,
        setCleanChip
    } = AddEditShiftApp();

    return (<>
        <HeadTittle
            link={routes.foodie.list}
            name={id ? 'update' : 'create'}
            divStack={ !id ?
                <div className={"ml-1"}>
                    <ButtonIcon
                        id='btn_aes_clean_fields'
                        Icon={CleanIcon}
                        onClick={handleClearFields}
                        title={'clear_instances'}
                        className={"btn-clean-secondary-600"}
                        tooltipPlacement={"right"}
                        iconProps='btn-icon-svg-12px icon-color-general-00'
                    />
                </div>
                : null
            }
        >
            {( DEV || permission?.includes(permissionObj?.WEB_FOODIE_SHIFT_CREATE) || permission?.includes(permissionObj?.WEB_FOODIE_SHIFT_UPDATE) ) &&
                <ButtonAction
                    id='btn_aes_update_data'
                    name={id ? 'update' : 'create'}
                    className='btn-icon-edit'
                    Icon={id? EditIcon:AddIcon }
                    onClick={() => {
                        handleAddEdit();
                    }}
                />
            }
        </HeadTittle>
        <DivContainerBody>
            <div className='row mt-4'>
            <div className='col-12'>
                <CustomTextField
                    id='txt_aes_name'
                    name='name'
                    value={item?.name}
                    trans='name'
                    type='text'
                    disabled={disabled}
                    onChange={handleChange}
                    emptyFields={emptyFields}
                    required={true}
                    length={64}
                />
            </div>

            <div className='col-12 mb-3'>
                <DividerWithText title={t('diners')} />
            </div>

            <div className='col-12'>
                <CustomAddChip
                    autocompleteId='atc_aes_cafeterias'
                    buttonId='btn_aes_cafeterias'
                    label='diner'
                    data={userListToLabelEmailPhoneValue(cafeteriasOptions, 'id', false, undefined)}
                    noDisabledChip={true}
                    selectedList={cafeterias}
                    setSelectedList={setCafeterias}
                    emptyFields={emptyFields && cafeterias.length <=0 }
                    cleanChipSearch={cleanChip}
                    setCleanChipSearch={setCleanChip}
                    reset={false}
                />
            </div>

            <div className='col-12 my-3'>
                <DividerWithText title={t('departments')} />
            </div>

            <div className='col-12'>
                <CustomAddChip
                    autocompleteId='atc_aes_department'
                    buttonId='btn_aes_department'
                    label='department'
                    data={userListToLabelEmailPhoneValue(departmentsOptions, 'id', false, undefined)}
                    filterOptions={filterByLabelEmailPhone}
                    selectedList={departments}
                    setSelectedList={setDepartments}
                    required={false}
                    cleanChipSearch={cleanChip}
                    setCleanChipSearch={setCleanChip}
                    noDisabledChip={true}
                    reset={false}
                />
            </div>
            <div className='col-12 my-3'>
                <DividerWithText title={t('custom_access')} />
            </div>

            <div className='col-12'>
                <CustomAddChipSearch
                    id="slt_aes_search_users"
                    selectedList={user}
                    setSelectedList={setUser}
                    userTypeIdsSearch={[
                        USER_TYPE_MODEL.VISITOR,
                        USER_TYPE_MODEL.EMPLOYEE,
                        USER_TYPE_MODEL.CONTRACTOR_IN_CHARGE,
                        USER_TYPE_MODEL.SUPPLIER_IN_CHARGE
                    ]}
                    disabled={false}
                    label="name"
                    required={false}
                    reset={false}
                    hideButton={false}
                    keyId={"userId"}
                    showSubSection={true}
                    sanitizeDataList={userListToLabelEmailPhoneValue}
                    Icon={PersonChipBlack}
                />
            </div>
          </div>
        </DivContainerBody>
    </>)
}

export default AddEditShift;
